import { getCalendarDateStringInTimeZone } from 'lib/datetime/dateUtils'
import isUpcoming, { isOrderCurrent, isOnlyExperiencesOrderUpcoming, isTransferItemUpcoming, isTransferItemCurrent } from './isUpcoming'

export function getTransferzOrderActivity(
  order: App.Order,
  bookingDetailsMap: Record<string, App.ExperienceBookingDetails>,
  isSpoofed = false,
): boolean | undefined {
  const transferzItems = order.transferItems.filter(item => item.provider === 'tfz')
  if (!transferzItems.length) return undefined

  const orderWithoutTransferz = {
    ...order,
    transferItems: order.transferItems.filter(item => item.provider !== 'tfz'),
  }
  if (isUpcoming(orderWithoutTransferz, isSpoofed) || isOrderCurrent(orderWithoutTransferz, isSpoofed) || isOnlyExperiencesOrderUpcoming(orderWithoutTransferz)) {
    return true
  }

  return transferzItems.some(item => {
    if (item.status === 'cancelled') return false

    const pickupTimeZone = bookingDetailsMap[item.id]?.providerData?.pickupTimeZone
    if (!pickupTimeZone) return isTransferItemUpcoming(item) || !!isTransferItemCurrent(item)

    return item.date >= getCalendarDateStringInTimeZone(new Date(), pickupTimeZone)
  })
}
